import { Sections as RenderSections } from "@lumora/ui";
import type { ComponentType } from "react";
import type { LayoutName } from "./variant.js";
import { Hero } from "./sections/Hero.js";
import { Highlights } from "./sections/Highlights.js";
import { Cta } from "./sections/Cta.js";
import { PackagesSection } from "./sections/PackagesSection.js";
import { Process } from "./sections/Process.js";
import { Portfolio } from "./sections/Portfolio.js";
import { Faq } from "./sections/Faq.js";

export type SectionKey = "hero" | "highlights" | "packages" | "process" | "portfolio" | "faq" | "cta";

// Single source of truth wiring a section key to its View. Functionality lives
// here once; layouts below only choose which sections render and in what order.
export const SECTIONS: Record<SectionKey, ComponentType> = {
  hero: Hero,
  highlights: Highlights,
  cta: Cta,
  packages: PackagesSection,
  process: Process,
  portfolio: Portfolio,
  faq: Faq,
};

// Each named layout is just an ordered list of section keys. Add or reorder to
// create a new "look" without touching any component or its behavior.
export const LAYOUT_SECTIONS: Record<LayoutName, SectionKey[]> = {
  standard: ["hero", "highlights", "packages", "process", "portfolio", "faq", "cta"],
  compact: ["hero", "packages", "portfolio", "cta"],
  editorial: ["hero", "portfolio", "highlights", "packages", "process", "faq", "cta"],
  story: ["hero", "process", "portfolio", "packages", "faq", "cta"],
};

export function Sections({ layout }: { layout: LayoutName }) {
  return (
    <RenderSections layout={layout} layoutSections={LAYOUT_SECTIONS} sections={SECTIONS} />
  );
}
